import { BaseUseCase } from "../../../useCases/UseCaseBase";
class LimitsUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getLimits(req);
    }
}
export default LimitsUseCase;
